import type { FigmaIconProps } from './types';

interface IconFigmaArrowRightProps extends FigmaIconProps {
  strokeWidth?: number;
}

export const IconFigmaArrowRight = ({
  size = 15,
  color = 'currentColor',
  strokeWidth = 2
}: IconFigmaArrowRightProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.125 7.5H11.875"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 3.125L11.875 7.5L7.5 11.875"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
